const INSURANCES_TYPE = {
    HOME_NOT_RELATED: 'NOT_RELATED',
    HOME_MORTGAGE_RELATED: 'RELATED',
    MOBILE_NOT_RELATED: 'MOBILE_NOT_RELATED'
}

const PRODUCT_TYPE = {
    HOME: 'HOME',
    MOBILE_INSURANCE: 'MOBILE_INSURANCE'
};

const RECEIPT_STATUS = {
    PAID: 'PAID'
}

const POLICY_STATUS = {
    VIGOR: 'VIGOR'
}

module.exports = {
    INSURANCES_TYPE,
    PRODUCT_TYPE,
    RECEIPT_STATUS,
    POLICY_STATUS
}